import { render } from "./CategorySmallFeatureArticle.vue?vue&type=template&id=7fe9056e"
import script from "./CategorySmallFeatureArticle.vue?vue&type=script&lang=js"
export * from "./CategorySmallFeatureArticle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__